// extracted by mini-css-extract-plugin
export default {"mobileControls":"vIUpwyIwn_s1LGSRocsI","mobileControlsRecording":"LZBGT2bm98yfELsCX38E"};